var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full",attrs:{"id":"site-report-router-wrapper"}},[_c('SiteReportRouteContainer',{attrs:{"siteId":_vm.siteId,"isShared":_vm.isShared}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }